import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ComptageLigneDto, ComptageLignesLexiClient } from '@lexi-clients/lexi';
import { DxDataGridComponent } from 'devextreme-angular';
import { ExportingEvent } from 'devextreme/ui/data_grid';
import { AuthService } from 'lexi-angular/src/app/settings/auth.service';
import { ExportDataGridService } from 'lexi-angular/src/app/shared/services/export-data-grid.service';
import { lastValueFrom } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';

@Component({
    selector: "app-bon-detail-articles-non-prevus",
    templateUrl: "./bon-detail-articles-non-prevus.component.html",
    styleUrls: ["./bon-detail-articles-non-prevus.component.scss"],
    standalone: false
})
export class BonDetailArticlesNonPrevusComponent implements OnInit {
  @ViewChild(DxDataGridComponent, { static: false })
  dataGrid: DxDataGridComponent;

  @Input() bonId: number;
  @Input() refreshTab: Observable<boolean>;
  @Output() nbArticlesNonPrevusChanged = new EventEmitter<number>();

  datasource: ComptageLigneDto[];

  get siteId(): number {
    return this.authService.getStoredSite()?.id;
  }

  constructor(
    private readonly comptageLignesClient: ComptageLignesLexiClient,
    private readonly authService: AuthService,
    private readonly exportDataGridService: ExportDataGridService,
  ) {}

  ngOnChanges(changes) {
    if (changes.refreshTab) {
      this.loadData();
    }
  }

  ngOnInit() {
    this.loadData();
  }

  clearDatagridFilters(dataGrid: DxDataGridComponent) {
    dataGrid?.instance?.clearFilter();
  }

  async loadData() {
    this.datasource = await lastValueFrom(this.comptageLignesClient.getArticlesNonPrevusByBonId(this.bonId));
    this.nbArticlesNonPrevusChanged.emit(this.datasource.length);
  }

  onExporting(e: ExportingEvent, filename: string) {
    this.exportDataGridService.onExporting(e, filename);
  }
}
